import { error, info, success } from '@/utils/toast';
import { Warning, SuccessFilled } from '@element-plus/icons-vue';

export function errorToast(message) {
    error({
        message,
        customClass: 'sfe-toast-light sfe-toast-error loan-sfe-toast',
    });
}

export function infoToast(message) {
    info({
        message,
        icon: Warning,
        customClass: 'sfe-toast-light sfe-toast-info loan-sfe-toast',
    });
}

export function successToast(message) {
    success({
        message,
        icon: SuccessFilled,
        customClass: 'sfe-toast-light sfe-toast-success loan-sfe-toast',
    });
}
